module.exports = __webpack_public_path__ + "media/images/icons/nbc_logo2-65beece06b2b14d77a164234fdf82ba3.png";